// extracted by css-extract-rspack-plugin
export default {"root":"root-3I1Nd","checkbox":"checkbox-2dkYa","striped":"striped-3-87Q","fixedFirstColumn":"fixedFirstColumn-2XpLb","stickyHeader":"stickyHeader-23Sax"};